import { Component, OnInit } from '@angular/core';
import { PlanService } from '../_services/plan.service';
import { Router } from '@angular/router';
import { AlertifyService } from '../_services/alertify.service';
import { LessonPlan } from '../_models/lessonPlan';
import { Member } from '../_models/member';
import { AuthService } from '../_services/auth.service';
import { CommonModule } from '@angular/common';
import { BlockUIModule } from 'ng-block-ui';
import { PlanMember } from '../_models/planMember';
import { DatePipe } from '@angular/common';
import { PlanMemberResponse } from '../_models/planMemberResponse';

@Component({
  selector: 'app-lessonPlans',
  standalone: true,
  imports: [ CommonModule, BlockUIModule ],
  templateUrl: './lessonPlans.component.html',
  styleUrls: ['./lessonPlans.component.css']
})
export class LessonPlansComponent implements OnInit {
  isActive: boolean = true;
  loaded = false;
  member: Member;
  lessonPlans: LessonPlan[];
  filteredPlans: LessonPlan[];
  invitations: LessonPlan[];

  constructor(private router: Router, private alertify: AlertifyService
    , private planService: PlanService, private authService: AuthService, public datePipe: DatePipe) { }

  ngOnInit() {
    this.member = this.authService.currentMember;
    this.planService.getLessonPlans().subscribe(plans=> {
      this.lessonPlans = plans;
      this.filteredPlans = this.applyFilters(plans);
      this.invitations = this.getInvitations(plans);
      this.loaded = true;
    }, error => {
      this.alertify.error(error);
    });
  }

  changeIsActive(event: any) {
    const checked = (event.target as HTMLInputElement).checked;
    this.isActive = checked;
    this.filteredPlans = this.applyFilters(this.lessonPlans);
  }

  applyFilters(lessonPlans: LessonPlan[]) {
    var filteredPlans = lessonPlans
      .filter(lp => 
        lp.isActive === this.isActive
        && (
          lp.member.id == this.member.id
          || lp.planMembers.filter(pm => pm.accepted
              && pm.member != null
              && pm.member.id === this.member.id
          ).length > 0)
      );
      return filteredPlans;
  }

  displayParticipants(planMembers: PlanMember[]) {
    return planMembers.filter(pm => pm.member != null).map(pm => pm.member.knownAs).join(', ');
  }
  
  displayInvitees(planMembers: PlanMember[]) {
    return planMembers.filter(pm => pm.member === null).map(pm => pm.emailAddress).join(', ');;
  }

  viewPlan(planId: number) {
    this.router.navigate(['lessonPlan/view/' + planId]);
  }
  
  editPlan(planId: number) {
    this.router.navigate(['lessonPlan/edit/' + planId]);
  }

  respond(plan: LessonPlan, value: boolean) {
    var myPlanMember = plan.planMembers.find(pm => pm.accepted == null && this.member.logins.filter(l => l.email === pm.emailAddress).length > 0);
    if (myPlanMember) {
      const planMemberResponse : PlanMemberResponse = { planMemberId: myPlanMember.id, value: value };
      this.planService.planMemberRespond(planMemberResponse).subscribe(response => {
        var message = "Successfully " + (response.value ? "accepted": "rejected");
        this.alertify.success(message);
        this.planService.getLessonPlans().subscribe(plans => {
          this.filteredPlans = this.applyFilters(plans);
          this.invitations = this.getInvitations(plans);
        }, (error) => {
          this.alertify.error(error);
        });
      })
    }    
  }

  getInvitations(lessonPlans: LessonPlan[]) {
    var invitations = lessonPlans
      .filter(lp => 
        lp.planMembers.filter(pm => pm.accepted == null && this.member.logins.filter(l => l.email === pm.emailAddress).length > 0
        ).length > 0
      );
      var lp = lessonPlans[0];
      return invitations;
  }

  canUpdate(plan: LessonPlan) {
    
    var canUpdate = plan.planMembers.filter(planMember => 
      planMember.canUpdate 
      && planMember.accepted 
      && this.member.logins.find(login => 
        login.email.toLowerCase() === planMember.emailAddress.toLowerCase()
      ) != null
    );
    var result = plan.member.id == this.member.id || canUpdate.length > 0

    return result;
  }
}
